import { Plus } from 'assets/icons';
import Button from 'components/button';
import Tooltips from 'components/tooltips/Tooltips';
import useHomeText from 'hooks/useHomeText';
import OrderHelp from './OrderHelp';

/**
 * The head of « Tâches du jour »: its title, what is left to do (and how much
 * of it is late), the explanation of the order, and the button that adds a task (also the N key).
 * Without `count`, the line under the title is drawn in grey, still loading.
 */
const TasksHeader = ({ count, late = 0, lateShown, onAdd }) => {
  const { text, plural } = useHomeText();
  return (
    <div className="flex items-start justify-between gap-4">
      <div className="flex min-w-0 flex-col">
        <h2 className="text-lg font-semibold leading-7 text-gray-900">{text('tasks.title')}</h2>
        {count === undefined ? (
          <span className="flex h-4 items-center">
            <span className="h-3 w-56 animate-pulse rounded bg-gray-200" />
          </span>
        ) : (
          <div className="flex items-center gap-2">
            <p className="text-xs leading-4 text-gray-600">
              {plural('tasks.count', count)}
              {late > 0 && text('tasks.countLate', { count: late })}
            </p>
            <OrderHelp lateShown={lateShown} />
          </div>
        )}
      </div>
      <Tooltips text={text('tasks.addTooltip')} placement="bottom">
        <Button color="PRIMARY" size="SM" className="shrink-0" onClick={onAdd}>
          <Plus wh={18} color="currentColor" />
          {text('tasks.add')}
        </Button>
      </Tooltips>
    </div>
  );
};

export default TasksHeader;
